import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { IState } from '../../../../redux/store';
import { urls } from '../../../../config/url';

import httpRequest from '../../../../utils/HttpRequest';
import useActiveModule from '../../../../oldPage/newpage/progress/utils/useActiveModule';
import { stat } from 'fs';
import { useProgressImageShow } from '../../../../oldPage/newpage/progress/progressImage/ProgressImageShow';
import ProgressBlock from '../../../../oldPage/newpage/progress/progressBlock/ProgressBlock';
import TableWithPagination from '../../../../components/table/tableWithPagination/TableWithPagination';
import useTableDataWithPagination from '../../../../components/table/tableWithPagination/useTableDataWithPagination';
import { ITableSet } from '../../../../components/table/Table';
import { useUIStack } from 'uistack';
import { Button, Modal, Table, message } from 'antd';
import { FetchFileViewer } from '../../../../components/fileView/FileViewer';
import { ViewType } from '../../../../components/fileView/FileType';
import FetchButton from '../../../../components/fetchButton/FetchButton';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { table } from 'console';


interface IJobMonitor {
    JOB_NAME: string
    JOB_STATUS: number
    JOB_STATUSMSG: string
    PROJECTNAME: string
    PRO_MODULE_NAME: string
    SPECIALITYCLASS: string
    SUBMIT_TIME: number
    TECHNOLOGYCLASS: string
    USER_NAME: string
    errormsg: string
    proj_name: string
    start_time: number
    update_time: string
    SERVICE_HOST?: string
    SERVICE_PID?: string
    SERVICE_NAME?: string
}

function ProgressImage(props: {
    userName: string, //用户名
    activeProjectName: string, //当前工区
    PRO_MODULE_NAME: string,
    line: any,
    testName: string,
    tabKey:string
}) {
    const uistack = useUIStack();
    const [itemData, setItemData] = useState<any>([])
    const [visible, setvisible] = useState<boolean>(false)
    const { spec, tech } = useParams<{ spec: string, tech: string }>();
    const tableSets: ITableSet[] = [
        {
            titleId: "serial_number",
            cover: (rowIndex: number) => {
                return <>{rowIndex + 1}</>
            }
        },
        {
            titleId: "update_time",
            key: "SUBMIT_TIME",
            handleSort: (a, b) => { return a ? b ? a.localeCompare(b, 'zh-CN') : 1 : -1 },
            cover: (rowIndex, rowData: IJobMonitor) => {
                return <>{new Date(rowData.SUBMIT_TIME).toLocaleString()}</>;
            }
        },
        // {
        //     titleId: "job_name",
        //     key: "JOB_NAME",
        //     handleSort: (a, b) => { return a ? b ? a.localeCompare(b, 'zh-CN') : 1 : -1 }
        // },
        {
            titleId: "job_status",
            key: "JOB_STATUSMSG",
            handleSort: (a, b) => { return a ? b ? a.localeCompare(b, 'zh-CN') : 1 : -1 }
        },
        {
            titleId: "job_runing_message",
            key: "errormsg"
        },

        {
            titleId: '日志显示',
            key: "JOB_STATUSMSG",
            cover: (rowIndex, rowData: IJobMonitor) => {
                return rowData.JOB_STATUS === 3 || rowData.JOB_STATUS === 4 ? <Button
                    type='primary'
                    onClick={() => {
                        setItemData(rowData)
                        setvisible(true)
                        uistack.push(visible =>
                            <Modal
                                maskClosable={false}
                                visible={visible}
                                centered
                                footer={null}
                                bodyStyle={{
                                    fontWeight: 'normal',
                                    padding: '0px',
                                }}
                                title={rowData.JOB_NAME}
                                onCancel={() => {
                                    uistack.pop()
                                }}
                                width={'calc(98vh - 3.5rem)'}
                            >
                                <div
                                    style={{
                                        overflowY: 'auto',
                                        maxHeight: 'calc(90vh - 3.5rem)',
                                        padding: '15px'
                                    }}
                                >
                                    <FetchFileViewer
                                        fetch={() => httpRequest(urls.getjoblog, {
                                            USER_NAME: props.userName,
                                            PROJECTNAME: props.activeProjectName,
                                            JOB_NAME: rowData.JOB_NAME,
                                            // SPECIALITYCLASS: spec,
                                            // TECHNOLOGYCLASS: tech,
                                            proj_name: rowData.proj_name,
                                        }).then(res => {
                                            let data = res.data;
                                            if (data.errno === 0) {
                                                return data.data;
                                            } else {
                                                return data.errmsg;
                                            }

                                        })}
                                        type={ViewType.TEXT}
                                    />
                                </div>
                            </Modal>
                        )
                    }}
                >
                    查看日志
                </Button> : <></>;
            }
        },
        // {
        //     titleId: "module_name",
        //     key: "PRO_MODULE_NAME"
        // },
        {
            titleId: "empty",
            cover: (rowindex: number, rowData: IJobMonitor) => {
                return (
                    <>
                        {rowData.JOB_STATUSMSG === "running" || rowData.JOB_STATUSMSG === "wait" ?
                            <FetchButton className="btn btn-primary" fetch={async () => {
                                Modal.confirm({
                                    title: '中止作业',
                                    icon: <ExclamationCircleOutlined />,
                                    content: `需要中止作业${rowData.JOB_NAME}?`,
                                    onOk: async () => {
                                        const res = await httpRequest(urls.killServiceProcess, rowData);
                                        if (res.data.errno === 0) {
                                            param.update();
                                        } else {
                                            message.error(res.data.errmsg);
                                        }
                                    }
                                });
                                // <FormattedMessage
                                //     id="is_kill"
                                //     defaultMessage="Is kill the progress {jobName}?"
                                //     description="kill the Job"
                                //     values={{}}
                                // />

                                // if (isKill) {
                                //     const res = await httpRequest(urls.killServiceProcess, rowData);
                                //     if (res.data.errno === 0) {
                                //         param.update();
                                //     } else {
                                //         console.error(res.data.errmsg);
                                //     }
                                // }
                            }}>
                                <FormattedMessage id="kill" defaultMessage="kill" description="kill progress" />
                            </FetchButton> : <></>
                        }
                        <Modal
                                maskClosable={false}
                                visible={visible}
                                centered
                                footer={null}
                                bodyStyle={{
                                    fontWeight: 'normal',
                                    padding: '0px',
                                }}
                                title={rowData.JOB_NAME}
                                onCancel={() => {
                                    setvisible(false)
                                }}
                                width={'calc(98vh - 3.5rem)'}
                            >
                                <div
                                    style={{
                                        overflowY: 'auto',
                                        maxHeight: 'calc(90vh - 3.5rem)',
                                        padding: '15px'
                                    }}
                                >
                                    <FetchFileViewer
                                        fetch={() => httpRequest(urls.getjoblog, {
                                            USER_NAME: props.userName,
                                            PROJECTNAME: props.activeProjectName,
                                            JOB_NAME: itemData.JOB_NAME,
                                            SPECIALITYCLASS: spec,
                                            TECHNOLOGYCLASS: tech,
                                            proj_name: itemData.proj_name,
                                        }).then(res => {
                                            let data = res.data;
                                            if (data.errno === 0) {
                                                return data.data;
                                            } else {
                                                return data.errmsg;
                                            }

                                        })}
                                        type={ViewType.TEXT}
                                    />
                                </div>
                            </Modal>
                    </>
                )
            }
        }
    ]
  
    const param = useTableDataWithPagination(urls.listUserJobStatus, {
        USER_NAME: props.userName,
        PROJECTNAME: props.activeProjectName,
        proj_name: props.testName,
        SPECIALITYCLASS: spec,
        TECHNOLOGYCLASS: tech
    });
   
    useEffect(() => {
        param.update();
    }, [props.testName,props.tabKey])
    const columns = [
        {
          title: '序号',
          dataIndex: '序号',
        },
        {
          title: '提交时间',
          dataIndex: '提交时间',
        },
        {
          title: '作业状态',
          dataIndex: '作业状态',
        },
        {
            title: '执行信息',
            dataIndex: '执行信息',
          },
          {
            title: '日志显示',
            dataIndex: '日志显示',
          },
      ];
    return <>

        {
            props.testName === undefined ? <table className='table gsde'>
                <tr>
                    <th className='text-nowrap text-truncate' style={{background: '#f0f2f9'}}>序号</th>
                    <th className='text-nowrap text-truncate' style={{background: '#f0f2f9'}}>提交时间</th>
                    <th className='text-nowrap text-truncate' style={{background: '#f0f2f9'}}>作业状态</th>
                    <th className='text-nowrap text-truncate' style={{background: '#f0f2f9'}}>执行信息</th>
                    <th className='text-nowrap text-truncate' style={{background: '#f0f2f9'}}>日志显示</th>
                </tr>
            </table> : <TableWithPagination param={param} tableSets={tableSets} />
        }
        


    </>
}

const mapStateToProps = (state: {
    user: { userName: string }
    project: { activeName: string },
    progress: any
}) => {

    return {
        userName: state.user.userName, //用户名
        activeProjectName: state.project.activeName, //当前工区
        line: state.progress.line,
        PRO_MODULE_NAME: state.progress.modules.modules[0].PRO_MODULE_NAME,
        testName: state.progress.params.proj_name
    };
};
export default connect(mapStateToProps)(ProgressImage);